import moment from 'moment';
import 'moment-timezone';


export default {
  methods: {
    dateDefault(date) {
      if (!date) return null
      const zone = moment.tz.guess()
      return moment(date).tz(zone).format('DD.MM.YYYY')
    },
    dateYear(date) {
      if (!date) return null
      return moment(date).format('YYYY')
    },
    dateIso(date) {
      if (!date) return null
      return moment(date).format('DD.MM.YYYY HH:mm')
    },
    dateBack(date) {
      if (!date) return null
      return moment(date).format('YYYY-MM-DD')
    },
    dateTime(date, sep) {
      if (!date) return null
      return sep ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    timeIso(date) {
      if (!date) return null
      const zone = moment.tz.guess()
      return moment(date).tz(zone).format('HH:mm')
    },
    unixTime(date) {
      if (!date) return null;
      return parseInt(new Date(date).getTime() / 1000)
    },
    date(date, detail = false) {

      if (!date) return null;
      if (detail) {
        return moment.unix(date).format('DD.MM.YYYY HH:mm');
      } else
        return moment.unix(date).format('DD.MM.YYYY');
    },

    bytesToSize(bytes) {
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Byte';
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    getDateTz (date, zone) {

      if (!date) date = new Date;
      var format = 'YYYY/MM/DD HH:mm:ss';
      return new Date(moment(date, format).tz(zone).format(format));
    },
    convertTimeZone  (date, zone) {
      if (!date) date = new Date;

        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: zone}));

    }
  }
}
